import { Box, Heading, Stack } from "@sembark-travel/ui-base"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"
import { Helmet } from "react-helmet-async"
import { ActivityLogs } from "../../../../ActivityLogs"
import { useParams } from "../../../../router-utils"

function HotelActivities() {
	const { hotelId } = useParams("/hotels/:hotelId")
	return (
		<>
			<Helmet>
				<title>Hotel Activity Logs</title>
			</Helmet>
			<Box padding="6" bgColor="default" roundedBottom="md">
				<ForbidUnlessAuthorized anyPermissions={[PERMISSIONS.VIEW_HOTELS]}>
					<Stack gap="2">
						<Heading as="h5">Activity Logs</Heading>
						<ActivityLogs
							subjectType="hotels"
							subjectId={Number(hotelId)}
							hideTrackingInfo
						/>
					</Stack>
				</ForbidUnlessAuthorized>
			</Box>
		</>
	)
}

export default HotelActivities
